import type React from "react"
import { memo } from "react"

interface UserAvatarProps {
  size?: "small" | "medium" | "large"
  className?: string
}

const UserAvatar: React.FC<UserAvatarProps> = memo(({ size = "medium", className = "" }) => {
  const sizeMap = {
    small: { width: "16", height: "16" },
    medium: { width: "24", height: "24" },
    large: { width: "32", height: "32" },
  }

  const { width, height } = sizeMap[size]

  return (
    <div className={`user-avatar ${className}`}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </div>
  )
})

UserAvatar.displayName = "UserAvatar"

export default UserAvatar
